<template>
  <search-group-form-page
      v-if="group"
      :key="`edit-group-${group_id}-${group.updated_at}`"
      :url="`projects/${project_id}/searches/group_library/${group_id}`"
      :resource-name="resourceName"
      :item_id="group_id"
      :item="group"
      :title="$t('booleanSearch.edit_bool_group')"
      :detail-fields="['name', 'boolDescription']"
      :hide-filters="true"
      :is-busy="isBusy"
  />
</template>

<script>
// Plugins
import { mapActions, mapState } from "vuex";

// Components
import SearchGroupFormPage from "../../components/boolean-search/SearchGroupFormPage.vue";
// Mixins
import notifyMessages from "../../mixins/boolean-search/notifyMessages";

export default {
  name: "edit-group",

  props: {
    group_id: { // prop from $router
      type: String,
      required: true
    }
  },

  mixins: [ notifyMessages ],

  async created() {
    const id = parseInt(this.group_id)
    this.$store.commit('booleanSearch/RESET_SINGLE_RESOURCE', this.resourceName)
    await this.getQuery({url: `projects/${this.project_id}/searches/group_library/${id}`, key: this.resourceName}).catch(() => this.notifyStoreError())
  },

  data() {
    return {
      resourceName: 'group',
    }
  },

  computed: {
    ...mapState({
      project_id: state => state.booleanSearch.project_id,
      group: state => state.booleanSearch.group,
    }),
    isBusy() { return this.group.isBusy },
  },

  methods: {
    ...mapActions({
      getQuery: 'booleanSearch/getSingleResource',
    }),
  },

  components: {
    SearchGroupFormPage
  }
}
</script>